// apps/web/src/components/ui/EmptyState.tsx
import type { ReactNode } from "react";

export function EmptyState({
  icon, title, message, action,
}: { icon?: string; title?: string; message: string; action?: ReactNode }) {
  return (
    <div className="text-center mt-16 space-y-3 px-4">
      {icon && <div aria-hidden="true" className="text-4xl">{icon}</div>}
      {title && <p className="text-fg font-semibold">{title}</p>}
      <p className="text-fg-muted text-sm">{message}</p>
      {action && <div className="pt-1">{action}</div>}
    </div>
  );
}
